import { Component, HostBinding, OnInit } from "@angular/core";
import { RegistrationWizardComponent } from "./registration-wizard.component";
import { RegistrationComponent } from "./registration.component";

@Component({
  selector: "registration-wizard-step",
  template: `
    <ng-content></ng-content>
  `,
})
export class RegistrationWizardStepComponent implements OnInit {
  @HostBinding("style.display") styleDisplay = "none";
  private isCurrent = false;
  private step;

  constructor(private parent: RegistrationWizardComponent, private grandparent: RegistrationComponent) {
  }

  ngOnInit() {
    this.step = this.parent.addStep();

    this.isCurrent = this.step === this.parent.step;
    this.styleDisplay = this.isCurrent ? "block" : "none";

    this.parent.stepChange.subscribe((step) => {
      this.isCurrent = this.step === step;
      this.styleDisplay = this.isCurrent ? "block" : "none";
      if (this.isCurrent) {
        this.markFormsAsTouched(this.parent.step);
      }
    });

    this.grandparent.stepChange.subscribe((step) => {
      this.isCurrent = this.step === step;
      this.styleDisplay = this.isCurrent ? "block" : "none";
      if (this.isCurrent) {
        this.markFormsAsTouched(this.parent.step);
      }
      this.grandparent.step = step;
    });
  }

  private markFormsAsTouched(currentStep: number) {
    if(currentStep === 2) {
      this.grandparent.registrationForm.controls["company"].markAsTouched();
      this.grandparent.registrationForm.controls["firstname"].markAsTouched();
      this.grandparent.registrationForm.controls["lastname"].markAsTouched();
      this.grandparent.registrationForm.controls["gender"].markAsTouched();
      this.grandparent.registrationForm.controls["remark"].markAsTouched();
    } else if (currentStep === 3) {
      this.grandparent.registrationForm.controls["street"].markAsTouched();
      this.grandparent.registrationForm.controls["zip"].markAsTouched();
      this.grandparent.registrationForm.controls["city"].markAsTouched();
      this.grandparent.registrationForm.controls["country"].markAsTouched();
      this.grandparent.registrationForm.get("equal_email").get("confirm_email").markAsTouched();
      this.grandparent.registrationForm.controls["one_of_two"].get("phone").markAsTouched();
    } else if (currentStep === 4) {
      this.grandparent.registrationForm.get("equal_password").get("confirm_password").markAsTouched();
      this.grandparent.registrationForm.controls["termsOfUse"].markAsTouched();
    }
  }
}
